import { ChainID, Timeframe } from '@ankr.com/chains-list';
import { ETelemetryTopOf } from 'multirpc-sdk';
import { useMemo } from 'react';

import { IUsePrivateStatsProps } from 'modules/stats/hooks/usePrivateStats';
import { mapChainIDToStatsPath } from 'modules/stats/utils/mapChainIDToStatsPath';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useJWTs } from 'domains/jwtToken/hooks/useJWTs';

import { chainsTimeframeToStatsTimeframeMap } from '../constants';

export interface IUsePrivateStatsParams {
  chainId?: ChainID;
  includeTrafficTimeline?: boolean;
  metrics: ETelemetryTopOf[];
  timeframe: Timeframe;
}

export const usePrivateStatsParams = ({
  chainId,
  includeTrafficTimeline,
  metrics,
  timeframe,
}: IUsePrivateStatsParams) => {
  const { group, isAccountInitializing, workerToken } = useAccount();

  const { jwts, loading: jwtsLoading } = useJWTs({ group, skipFetching: true });
  const hasJWTs = jwts.length > 0;

  const blockchains = useMemo(
    () => (chainId ? [mapChainIDToStatsPath(chainId)] : undefined),
    [chainId],
  );

  const skipFetching = !hasJWTs || jwtsLoading || isAccountInitializing;

  const privateStatsParams = useMemo(
    (): IUsePrivateStatsProps => ({
      blockchains,
      includeTrafficTimeline,
      metrics,
      skipFetching,
      timeframe: chainsTimeframeToStatsTimeframeMap[timeframe],
      workerToken: workerToken!,
    }),
    [
      blockchains,
      includeTrafficTimeline,
      metrics,
      skipFetching,
      timeframe,
      workerToken,
    ],
  );

  return { privateStatsParams };
};
